module.exports = __webpack_public_path__ + "static/media/user.2c6e94aa.png";